var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3Umbrella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.71 15H40v-3.25a2 2 0 00-4 0V15h-5L10 28.76v9.56c.73.43 1.28.94 2 1.28a4 4 0 001.83.4 3.89 3.89 0 002.17-.59c1.15-.71 1.81-1.82 3.86-1.82 3 0 3 2.41 6 2.41s3-2.41 6-2.41c2.18 0 2.78 1.26 4.1 2V61H26v4h24v-4H40V39.46c1.2-.71 1.84-1.87 3.94-1.87 3 0 3 2.41 6 2.41s3-2.41 6-2.41c2.14 0 2.76 1.22 4 1.92a4.29 4.29 0 004 0c.74-.42 1.26-1 2-1.42v-9.34L44.71 15zM28.42 34H14v-2.93L32.07 19h3l-6.65 15zM62 34H46.63l-5.85-15h2.88L62 31.08V34z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Umbrella.1ff6d98c.svg";
export { SvgE3Umbrella as ReactComponent };